import { render, staticRenderFns } from "./ProofOfIdModal.vue?vue&type=template&id=6158f6fb"
import script from "./ProofOfIdModal.vue?vue&type=script&lang=js"
export * from "./ProofOfIdModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports